import { render, staticRenderFns } from "./EstateCategoryFormItem.vue?vue&type=template&id=4aeb45e4&"
import script from "./EstateCategoryFormItem.vue?vue&type=script&lang=ts&"
export * from "./EstateCategoryFormItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports